import topic from '../topic'
export const smplAPI = {
    getSmpls: topic.smplTopic + '/get_smpls',
    getSmplById: topic.smplTopic + '/get_smpl_by_id',
    addSmpl: topic.smplTopic + '/add_smpl',
    editSmpl: topic.smplTopic + '/edit_smpl',
    destroySmplByIds: topic.smplTopic + '/destroy_smpl_by_ids'
}